import React from 'react';

import { Tag } from 'primereact/tag';

type ItemWithIdLabel = { id: string | number; label: string };

export const generateTags = <T extends object>(
  data: T | undefined,
  key: keyof T
): JSX.Element[] | null => {
  if (!data || !Array.isArray(data[key])) {
    console.error(`Invalid data for key "${String(key)}":`, data);
    return null;
  }

  const items = data[key] as unknown as ItemWithIdLabel[];

  return items.map((item) => (
    <Tag
      style={{ background: 'rgb(225, 234, 245)', color: '#495057' }}
      className="mr-1"
      key={item.id}
    >
      {item.label}
    </Tag>
  ));
};
